import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "otp-configuration",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const otpConfiguration = require("./OTPConfiguration").default;
          cb(null, otpConfiguration);
        },
        "otpConfiguration"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/OTPConfiguration/index.js